@if (course) {
  <div class="ibox" style="border: 1px solid #e7eaec; border-radius: 4px; margin: 8px; padding: 10px; background-color: #ffffff; box-sizing: border-box; width: 100%; max-width: 100%; overflow: hidden;">
    <div class="form-horizontal" style="width: 100%; max-width: 100%;">
      <div class="row" style="margin-left: 0; margin-right: 0; max-width: 100%;">
        <div class="col-sm-12">
          <div class="form-group">
            <label class="col-sm-2 control-label">Name:</label>
            <div class="col-sm-6">
              <input
                type="text"
                class="form-control"
                name="courseName"
                [(ngModel)]="course.name"
                (ngModelChange)="onCourseFieldChanged()"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">Short Name:</label>
              <div class="col-sm-1">
                <input
                  type="text"
                  class="form-control"
                  name="shortName"
                  [(ngModel)]="course.shortName"
                  (ngModelChange)="onCourseFieldChanged()"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">LPGA ID:</label>
                <div class="col-sm-2">
                  <input
                    type="number"
                    class="form-control"
                    name="lpgaId"
                    min="1"
                    required
                    [(ngModel)]="course.lpgaId"
                    (ngModelChange)="onCourseLpgaIdChanged($event)"
                    placeholder="Required"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Created On:</label>
                  <div class="col-sm-4 col-md-2">
                    <app-audit-info [dateUtc]="course.createdOnUtc"></app-audit-info>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Modified On:</label>
                  <div class="col-sm-4 col-md-2">
                    <app-audit-info [dateUtc]="course.modifiedOnUtc"></app-audit-info>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-left: 0; margin-right: 0; max-width: 100%;">
                <div class="col-sm-12" style="overflow: hidden; max-width: 100%; padding-left: 0; padding-right: 0;">
                  <app-hole-info [rounds]="rounds" [holes]="holes" [holeYardages]="holeYardages"
                  (holeChanged)="onHoleChange($event)" (holeYardageChanged)="onHoleYardageChange($event)"></app-hole-info>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="text-right" style="padding-right: 15px;">
                    <button (click)="save()" class="btn btn-primary" type="submit" [disabled]="!canSave">
                      <i class="fa fa-save"></i> Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }